import React, { useContext, useMemo } from 'react'
import { AllFilesTypes } from '../../types'
import { reportFilterContext } from './report-filter-context'
import { FilesCollapseGroup } from '../files-collapse-group'
import { ReportFilterValues } from './types'
import { NoFilteredItemsNote } from './no-items-note'

// Generic layout for page with derived files, where we should
// also apply filter to each file's content
export function MultiFilesFilteredLayout({
  data,
  filesType,
  applyFilter,
  fileContentComponent,
  dataProvider,
  selected,
}: {
  data: any
  filesType: AllFilesTypes
  applyFilter: (data: any, filter: ReportFilterValues | undefined) => any
  fileContentComponent: React.FunctionComponent
  dataProvider?: (fileKey: string) => { [key: string]: any }
  selected?: string
}) {
  const filterContext = useContext(reportFilterContext)
  const filterValues = filterContext.getValues()

  const dataItems = useMemo(() => {
    const result: { [fileKey: string]: JSX.Element } = {}

    Object.keys(data).forEach((fileKey) => {
      const skipFile = filterValues?.files && !filterValues?.files.includes(fileKey)
      if (skipFile) {
        return
      }

      const Component = fileContentComponent as any
      const filteredData = applyFilter(data[fileKey], filterValues)
      const hasData = (Array.isArray(filteredData) && filteredData.length) || Object.keys(filteredData || {}).length

      if (hasData) {
        result[fileKey] = <Component data={filteredData} key={fileKey} {...dataProvider?.(fileKey)} />
      }
    })

    return result
  }, [data, filterValues])

  if (filesType === AllFilesTypes.MainFile && Object.keys(dataItems).length) {
    return Object.values(dataItems)[0]
  }

  return Object.keys(dataItems).length ? (
    <FilesCollapseGroup data={dataItems} filesType={filesType} selected={selected} />
  ) : (
    <NoFilteredItemsNote />
  )
}
